import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

import { EvtNames, RxFormEvt } from '../types';

export function filteredEvents(stream$: Observable<RxFormEvt>, eventNames: EvtNames[]): Observable<RxFormEvt> {
    return stream$.pipe(filter((x) => eventNames.indexOf(x.type) > -1));
}
